import React from 'react'
import styles from './index.module.scss'
import { Tooltip } from 'antd'

interface IProps {
  label: string
  labelTip?: string
  children: JSX.Element | string
  required?:boolean
}

export default function FormItem({ label, labelTip, children,required }: IProps) {
  return (
    <div className={styles.formItem}>
      <div className={styles.labelWrap}>
        <p className={[styles.labelTxt,required? styles.labelTxtRequired:""].join(" ")}>{label}</p>
        {labelTip && (
          <div className={styles.tooltip}>
            <div className={styles.tipIcon}></div>
            <div className={styles.tooltipInner}>{labelTip}</div>
          </div>
        )}
      </div>
      <div className={styles.contentWrap}>{children}</div>
    </div>
  )
}
